import React, { useContext, useEffect } from "react";
import {withRouter} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal7 = ({ history: {push} }) => {
  const mainContext = useContext(MainContext)
  const {onChange, formData} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const moveForward = () => {
    push('/survey/7')
  };

  const {
    credits,
    school,
    age,
    firstName,
    lastName,
    zipCode,
    email,
    phone,
  } = formData;

  return (
    <section id="modal-7">
      <div className="container">
        <h2>Please confirm your details.</h2>
        <div className="middle">
          <p>
            Name: <strong>{`${firstName} ${lastName}`}</strong>
          </p>
          <p>
            Age: <strong>{age}</strong>
          </p>
          <p>
            ZIP Code: <strong>{zipCode}</strong>
          </p>
          <p>
            School: <strong>{school}</strong>
          </p>
          <p>
            Current Credits: <strong>{credits}</strong>
          </p>
          <p>
            {email && phone ? (<><p>
            Email: <strong>{email}</strong>
          </p>
          <p>
            Phone: <strong>{phone}</strong>
          </p></>) : "Email: "}
            <strong>{email === "" ? phone : email}</strong>
          </p>
        </div>
        <div className="summary-btns">
          <button onClick={moveForward} className="btn btn-red">
            Looks Good
          </button>
          <button onClick={() => {push('/survey/5')}} className="btn btn-green">
            Missed Something
          </button>
        </div>
      </div>
    </section>
  );
};

export default withRouter(Modal7);
